<div class="container-fluid p-3">
  <div class="bg-white rounded-md  border-2 border-blue-900 border-gray-300 px-4 py-2 sm:p-6 mb-4">
    <div class="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
    <div class="flex gap-3">
    
      <div class="flex-1">
        <h4 class="text-xl sm:text-2xl font-bold text-slate-800 mb-1">
          {{stepDetails?.name}}
        </h4>
    
        <h5 class="text-base sm:text-lg text-blue-600 font-semibold mb-3">
          [{{ payload?.proposal_name }}]
        </h5>
    
    
      </div>
      <div>
        
        <span class="inline-flex items-center px-3 py-1.5 border-2 rounded-full text-sm font-bold transition-all" [ngClass]="{
                        'bg-slate-100 text-slate-700 border border-slate-500': stepDetails?.step_status == 0,
                        'bg-emerald-100 text-emerald-700 border border-emerald-500': stepDetails?.step_status == 'approved',
                        'bg-amber-100 text-amber-700 border border-amber-500': stepDetails?.step_status == 'recommended',
                        'bg-blue-100 text-blue-700 border border-blue-500': stepDetails?.step_status == 'initiated'
                      }">
          <span class="w-2 h-2 rounded-full mr-2 animate-pulse" [ngClass]="{
                          'bg-slate-500': stepDetails?.step_status == 0,
                          'bg-emerald-500': stepDetails?.step_status == 'approved',
                          'bg-amber-500': stepDetails?.step_status == 'recommended',
                          'bg-blue-500': stepDetails?.step_status == 'initiated'
                        }"></span>
          {{ stepDetails?.step_status == 0 ? " PENDING" : (stepDetails?.step_status | uppercase) }}
        </span>
      </div>
    </div>

      <!-- Action Buttons -->
      <div class="flex flex-wrap items-center gap-2">

       

        <ng-container *ngIf="stepDetails?.can_edit">
          <button (click)="routeConfig.emit({isRouteConfig: true})"  class="inline-flex items-center px-4 py-2.5 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 disabled:bg-slate-300 disabled:cursor-not-allowed transition-all duration-200 font-medium text-sm shadow-sm hover:shadow-md">
            <i class="pi pi-save mr-2"></i> Save/Forward/Route Config
          </button>
        </ng-container>
      </div>
    </div>
  </div>

  <hr class="my-3" />




  <div class="row mb-4 mt-4">
    

            <app-upload-document [title]="stepDetails.name+' Document'" [isEditable]="stepDetails?.can_edit" >  </app-upload-document>
  </div>



  <form [formGroup]="commentForm" class="w-full mx-auto my-8">
    <div class="space-y-6">
      <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
        <!-- IFA/MoD Concurrence Date -->
        <div class="flex flex-col gap-1">
          <label for="startDate" class="mb-2 text-sm font-semibold bg-blue-800 text-white rounded-t px-3 py-2 flex items-center">
            IFA/MoD Concurrence Date
            <span class="ml-1 text-amber-400 text-lg">*</span>
          </label>
          <input
            type="date"
            id="startDate"
            formControlName="installation_date"
            class="border-2 border-blue-200 rounded px-3 py-2 focus:ring-2 focus:ring-blue-400 focus:outline-none transition duration-150 bg-white"
          />
        </div>
        <!-- CFA Approval Date -->
        <div class="flex flex-col gap-1">
          <label for="endDate" class="mb-2 text-sm font-semibold bg-blue-800 text-white rounded-t px-3 py-2 flex items-center">
            CFA Approval Date
            <span class="ml-1 text-amber-400 text-lg">*</span>
          </label>
          <input
            type="date"
            id="endDate"
            formControlName="delivery_date"
            class="border-2 border-blue-200 rounded px-3 py-2 focus:ring-2 focus:ring-blue-400 focus:outline-none transition duration-150 bg-white"
          />
        </div>
        <!-- Final Cost (INR) -->
        <div class="flex flex-col gap-1 ">
          <label for="final_cost" class="mb-2 text-sm font-semibold bg-blue-800 text-white rounded-t px-3 py-2 flex items-center">
            Final Cost (INR)
            <span class="ml-1 text-amber-400 text-lg">*</span>
          </label>
          <input
            type="number"
            id="final_cost"
            formControlName="final_cost"
            class="border-2 border-blue-200 rounded px-3 py-2 focus:ring-2 focus:ring-blue-400 focus:outline-none transition duration-150 bg-white"
          />
        </div>
      </div>
      <div class="flex flex-col ">
        <label class=" font-semibold text-base bg-blue-800 text-white px-3 py-2 rounded-t">
          TEC table
        </label>
        <div class="rounded-b border border-blue-200 bg-white">
          <editor [init]="init" formControlName="tec_table" ></editor>
        </div>
      </div>
      <!-- Justification Editor -->
      <div class="flex flex-col ">
        <label class="font-semibold text-base bg-blue-800 text-white px-3 py-2 rounded-t">
          {{schemeType === 'rev' ? 'Comment' : 'Justification'}}
        </label>
        <div class="rounded-b border border-blue-200 bg-white">
          <editor [init]="init" formControlName="final_offer" ></editor>
        </div>
      </div>
      <!-- <button type="submit" class="mt-4 px-6 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 disabled:bg-slate-300 disabled:cursor-not-allowed font-semibold shadow-sm transition">
        <i class="pi pi-save mr-2"></i> Submit
      </button> -->
    </div>
  </form>
</div>